import React from 'react';
import { Instagram, Facebook } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="w-full bg-[#3A3A3A] px-6 py-10" data-id="element-97">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-98">
        {/* Copyright */}
        <p className="text-[#FAF8F5]/60 text-sm order-3 md:order-1" data-id="element-99">
          © {currentYear} Cardkeeper. All rights reserved.
        </p>

        {/* Legal Links */}
        <nav className="flex items-center gap-6 order-1 md:order-2" data-id="element-100">
          <a href="/privacy" className="text-[#FAF8F5]/60 text-sm hover:text-[#FAF8F5] transition-colors" data-id="element-101">
            Privacy Policy
          </a>
          <a href="/terms" className="text-[#FAF8F5]/60 text-sm hover:text-[#FAF8F5] transition-colors" data-id="element-102">
            Terms of Service
          </a>
          <a href="/support" className="text-[#FAF8F5]/60 text-sm hover:text-[#FAF8F5] transition-colors" data-id="element-103">
            Support
          </a>
        </nav>

        {/* Social Links */}
        <div className="flex items-center gap-4 order-2 md:order-3" data-id="element-104">
          <a href="https://www.instagram.com/cardkeeperapp" target="_blank" rel="noopener noreferrer" className="text-[#FAF8F5]/60 hover:text-[#FAF8F5] transition-colors" aria-label="Follow Cardkeeper on Instagram" data-id="element-105">
            <Instagram className="w-5 h-5" data-id="element-106" />
          </a>
          <a href="https://www.facebook.com/people/Cardkeeper/61586847751889/" target="_blank" rel="noopener noreferrer" className="text-[#FAF8F5]/60 hover:text-[#FAF8F5] transition-colors" aria-label="Follow Cardkeeper on Facebook" data-id="element-107">
            <Facebook className="w-5 h-5" data-id="element-108" />
          </a>
        </div>
      </div>
    </footer>;
}